import React from 'react';
import tpl from '../templates/main';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';
import {apiback} from '../../../../../config';
import Model from '../components/installmentCalc/model/model.m';

const vygoda = 'credit_vygoda';

export default class extends BaseNewCardView {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            selectedType: vygoda,
            tab: 'get-services'
        };
    }

    componentWillMount() {
        fetch(apiback('INSTALLMENT_VYGODA'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new Model(json.data[vygoda])
                })
            );
        // .catch(x => console.log("error:", x)); todo добавить обработчик
    }

    static displayName = 'BoltCard.Views.Main';
}
